module.exports = __webpack_public_path__ + "static/media/logo.bf00e37f.svg";